export const MULTIPLE_CHOICE_QUESTIONS = 'Multiple choice questions';
export const PROBLEM_SOLVING = 'Problem solving';
export const DOUBLE_SPACING = '1';
export const SINGLE_SPACING = '2';